import React from "react";
import ManageSejarah from './ManageSejarah';
import ManageVisiMisi from './ManageVisiMisi';

export default function ManageProfileSekolah() {
  return (
    <div className="container mt-4">
      <h2>Kelola Profile Sekolah</h2>



      <div className="mt-4">
        <h4>Sejarah</h4>
        <ManageSejarah />
      </div>

      <div className="mt-4">
        <h4>Visi & Misi</h4>
        <ManageVisiMisi />
      </div>
    </div>
  );
}
